import * as React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'ramda';

import { ListingLayout } from '../../components/ListingLayout';
import { AgencyCard } from '../../components/AgencyCard';
import { getAgenciesItems } from '../../selectors/listing';
import { CardAvatarContainer } from '../CardAvatarContainer';
import { EmptyListingStubContainer } from '../EmptyListingStubContainer';
import { useOpenCard } from '../../utils/openCard';

export function AgenciesListingContainer() {
  const agenciesItems = useSelector(getAgenciesItems);
  const onClick = useOpenCard();

  if (isEmpty(agenciesItems)) {
    return <EmptyListingStubContainer />;
  }

  return (
    <ListingLayout>
      {agenciesItems.map(
        ({
          cianUserId,
          age,
          name,
          offersCount,
          services,
          userTrustLevelNumber,
          userTrustLevelName,
          hasRgrParticipation,
          hasKokonParticipation,
        }) => {
          return (
            <AgencyCard
              key={cianUserId}
              onClick={() => onClick(cianUserId)}
              agentId={cianUserId}
              previewImg={<CardAvatarContainer agentId={cianUserId} />}
              age={age}
              name={name}
              hasRgrParticipation={hasRgrParticipation}
              hasKokonParticipation={hasKokonParticipation}
              offersCount={offersCount}
              services={services}
              levelName={userTrustLevelName}
              levelNumber={userTrustLevelNumber}
            />
          );
        },
      )}
    </ListingLayout>
  );
}
